import { createIcon } from './create-icon'

export const ThumbsUp = createIcon({
  displayName: 'ThumbsUp',
  d: 'M597.333 384V213.333a128 128 0 0 0-128-128l-170.667 384v469.333h481.28a85.333 85.333 0 0 0 85.333-72.533l58.88-384a85.333 85.333 0 0 0-85.333-98.133zM298.667 938.667H170.667a85.333 85.333 0 0 1-85.333-85.333v-298.667a85.333 85.333 0 0 1 85.333-85.333h128',
  sx: {
    fill: 'white',
    stroke: 'currentColor',
    strokeWidth: 85.333,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }
})
